module.exports = __webpack_public_path__ + "static/media/images-02.2939f8a7.png";